window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  // Wized API is now loaded
  let fitness_type = '';
  let fitness_genre = '';
  let fitness_variations = '';
  let fitness_notes = '';
  let fitness_meta = {};

  let fitness_audio_main = document.querySelector('[data-name=fitness_main]');
  let fitness_audio_recovery = document.querySelector('[data-name=fitness_recovery]');
  let fitness_finished_workout = document.querySelector('[data-name=fitness_finished_workout]');
  let fitness_status_recovery = document.querySelector('[data-name=recovery-pill]');
  let fitness_confirm = document.querySelector('[data-name=fitness_confirm_session]');
  let exercise_fitness_audio_title = document.querySelector('[data-name=exercise_session_audio_title]');
  let exercise_fitness_audio_album = document.querySelector('[data-name=exercise_session_audio_album]');

  let recovery_fitness_audio_title = document.querySelector('[data-name=recovery_session_audio_title]');
  let recovery_fitness_audio_album = document.querySelector('[data-name=recovery_session_audio_album]');
  let fitness_review = document.querySelector('[data-name=session_review]');
  let fitness_notes_slide = document.querySelector('[data-name=session_notes_slide]');
  let fitness_type_subpage = document.querySelector('[data-name=exercise_type]');
  let fitness_playlist_subpage = document.querySelector('[data-name=select_playlist]');
  let begin_recording = document.querySelector('[data-name=begin_recording]');
  let end_recording = document.querySelector('[data-name=end_recording]');

  let is_recovery_ended = false;

  const audioPlayers = Array.from(document.querySelectorAll('audio')).map(
    (p) =>
      new Plyr(p, {
        controls: ['play', 'current-time', 'progress'],
      })
  );

  const videoPlayers = Array.from(document.querySelectorAll('video')).map(
    (p) =>
      new Plyr(p, {
        controls: ['play', 'current-time', 'progress', 'fullscreen'],
      })
  );

  const fitness_audio = [
    {
      genre: 'Pop A',
      tracks: [
        {
          type: 'Walk',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20A%20(Walk)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20A%20(Walk)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Run',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20A%20(Run)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20A%20(Run)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Row',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20A%20(Row)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20A%20(Row)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Cycling',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20A%20(Cycle)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20A%20(Cycle)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
      ],
    },
    {
      genre: 'Pop B',
      tracks: [
        {
          type: 'Walk',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20B%20(Walk)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20B%20(Walk)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Run',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20B%20(Run)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20B%20(Run)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Row',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20B%20(Row)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20B%20(Row)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Cycling',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Pop%20B%20(Cycle)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Pop%20B%20(Cycle)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
      ],
    },
    {
      genre: 'Classic Rock A',
      tracks: [
        {
          type: 'Walk',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20A%20(Walk)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20A%20(Walk)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Run',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20A%20(Run)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20A%20(Run)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Row',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20A%20(Row)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20A%20(Row)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Cycling',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20A%20(Cycle)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20A%20(Cycle)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
      ],
    },
    {
      genre: 'Classic Rock B',
      tracks: [
        {
          type: 'Walk',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20B%20(Walk)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20B%20(Walk)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Run',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20B%20(Run)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20B%20(Run)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Row',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20B%20(Row)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20B%20(Row)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Cycling',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Classic%20Rock%20B%20(Cycle)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20B%20(Cycle)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
      ],
    },
    {
      genre: 'Hip Hop A',
      tracks: [
        {
          type: 'Walk',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20A%20(Walk)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Hip%20Hop%20A%20(Walk)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Run',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20A%20(Run)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Hip%20Hop%20A%20(Run)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Row',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20A%20(Row)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Classic%20Rock%20A%20(Row)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Cycling',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20A%20(Cycle)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Hip%20Hop%20A%20(Cycle)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
      ],
    },
    {
      genre: 'Hip Hop B',
      tracks: [
        {
          type: 'Walk',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20B%20(Walk)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Hip%20Hop%20B%20(Walk)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Run',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20B%20(Run)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Hip%20Hop%20B%20(Run)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Row',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20B%20(Row)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Hip%20Hop%20B%20(Row)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
        {
          type: 'Cycling',
          variations: {
            treatment: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20(Enhanced)/E&R%202.1%20Hip%20Hop%20B%20(Cycle)%20Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Breathwork%20And%20Recovery%20For%20Review.mp4',
            },
            control: {
              main: 'https://cdn.soundbrilliance.com/Exercise%20and%20Recovery%202.1/Non%20Enhanced%20Versions/Pre%20Exercise%20and%20Exercise%20-%20Non%20Enhanced/E&R%202.1%20Hip%20Hop%20B%20(Cycle)%20NON-Enhanced%20-%20Pre%20Exercise%20and%20Exercise.wav',
              recovery:
                'https://cdn.soundbrilliance.com/Fitness%20Study/Fitness%202.0%20Recovery/Control%20Recovery.mp4',
            },
          },
        },
      ],
    },
  ];

  document.querySelectorAll('[fitness-type]').forEach(function (element) {
    element.addEventListener('click', function () {
      fitness_type = this.getAttribute('data-name');
    });
  });

  document.querySelectorAll('[genre]').forEach(function (element) {
    element.addEventListener('click', function () {
      fitness_genre = this.getAttribute('genre');
    });
  });

  // Define even or odd session
  function isEven(number) {
    return number % 2 === 0;
  }

  function isOdd(number) {
    return number % 2 !== 0;
  }

  const user = await Wized.requests.waitFor('get_user');
  let fitness_reset = isOdd(user.data.completed_sessions + 1);

  // Remove sub pages if fitness session is "odd"
  if (!fitness_reset) {
    fitness_type_subpage.remove();
    fitness_playlist_subpage.remove();
    fitness_notes_slide.remove();
  } else {
    fitness_review.classList.add('hide');
  }

  // Function to get the URL
  function getUrl(data, genre, type, variation, recovery = false) {
    const genreObj = data.find((g) => g.genre === genre);
    if (!genreObj) {
      return null;
    }

    const trackObj = genreObj.tracks.find((t) => t.type.toLowerCase() === type.toLowerCase());
    if (!trackObj) {
      return null;
    }

    if (recovery) {
      return trackObj.variations[variation.toLowerCase()]?.recovery || null;
    } else {
      console.log('src', trackObj.variations[variation.toLowerCase()]?.main)
      return trackObj.variations[variation.toLowerCase()]?.main || null;
    }
  }

  fitness_confirm.addEventListener('click', async function () {
    const study_group = user.data.study_groups_id;

    if (!fitness_reset) {
      // Get last session data
      fitness_meta = Wized.data.v.previous_completed_session.metadata;
    } else {
      fitness_meta = {
        type: fitness_type,
        genre: fitness_genre,
        variation: null,
        main: null,
        recovery: null,
        notes: null,
      };
    }

    // Group A = ID 4
    const group_a = 4;
    // Group B = ID 5
    const group_b = 5;
    let main_src = null;
    let recovery_src = null;

    if (study_group === group_a) {
      if (fitness_reset) {
        console.log('Group A (Odd Session) - Treatment');
        fitness_variations = 'Treatment';
        main_src = getUrl(fitness_audio, fitness_meta.genre, fitness_meta.type, 'treatment');
        recovery_src = getUrl(
          fitness_audio,
          fitness_meta.genre,
          fitness_meta.type,
          'treatment',
          true
        );
      } else {
        console.log('Group A (Even Session) - Control');
        fitness_variations = 'Control';
        main_src = getUrl(fitness_audio, fitness_meta.genre, fitness_meta.type, 'control');
        recovery_src = getUrl(
          fitness_audio,
          fitness_meta.genre,
          fitness_meta.type,
          'control',
          true
        );
      }
    } else if (study_group === group_b) {
      if (fitness_reset) {
        console.log('Group B (Odd Session) - Control');
        fitness_variations = 'Control';
        main_src = getUrl(fitness_audio, fitness_meta.genre, fitness_meta.type, 'control');
        recovery_src = getUrl(
          fitness_audio,
          fitness_meta.genre,
          fitness_meta.type,
          'control',
          true
        );
      } else {
        console.log('Group B (Even Session) - Treatment');
        fitness_variations = 'Treatment';
        main_src = getUrl(fitness_audio, fitness_meta.genre, fitness_meta.type, 'treatment');
        recovery_src = getUrl(
          fitness_audio,
          fitness_meta.genre,
          fitness_meta.type,
          'treatment',
          true
        );
      }
    } else {
      return;
    }

    // Set variation
    fitness_meta.variation = fitness_variations;
    fitness_meta.main = main_src;
    fitness_meta.recovery = recovery_src;

    // Load audio
    fitness_audio_main.src = main_src;
    fitness_audio_recovery.src = recovery_src;
    fitness_audio_main.load();
    fitness_audio_recovery.load();

    // Set exercise audio titles
    exercise_fitness_audio_title.textContent = fitness_meta.type;
    exercise_fitness_audio_album.textContent = fitness_meta.genre;

    // set recovery audio titles
    recovery_fitness_audio_title.textContent = fitness_meta.type;
    recovery_fitness_audio_album.textContent = fitness_meta.genre;

    // Hide recovery
    fitness_audio_recovery.closest('.plyr').style.display = 'none';
    fitness_finished_workout.style.display = 'none';
    end_recording.style.display = 'none';

    fitness_finished_workout.addEventListener('click', function () {
      this.style.display = 'none';
      begin_recording.style.display = 'none';
      end_recording.style.display = 'grid';
      fitness_audio_main.pause();
      fitness_audio_main.src = '';
      fitness_status_recovery.classList.remove('is-endstate');
      fitness_status_recovery.classList.add('background-color-recover');
      fitness_audio_main.closest('.plyr').style.display = 'none';
      fitness_audio_recovery.closest('.plyr').style.display = 'block';
      fitness_audio_recovery.play();
    });

    document.addEventListener('pre-recovery-screen', async function () {
      fitness_audio_main.pause();
    });
    document.addEventListener('recovery-screen', async function () {
      disableContinueButton(true);
    });
    document.addEventListener('post-session-page', async function () {
      console.log('i here')
      const backButton = document.querySelector('#backBtn');
      console.log('backbutton', backButton);
      backButton.classList.add('hide');
    });

    fitness_audio_main.addEventListener('timeupdate', function () {
      disableContinueButton(true);
    });

    fitness_audio_main.addEventListener('play', function () {
      disableContinueButton(true);
      fitness_finished_workout.style.display = 'inline-block';
    });

    fitness_audio_recovery.addEventListener('ended', function () {
      this.pause();
      if (!is_recovery_ended) {
        advancePage();
        is_recovery_ended = true;
      }
    });

    document.querySelectorAll('audio').forEach(function (audio) {
      audio.addEventListener('play', function () {
        const activated = this;
        // Pause other players
        document.querySelectorAll('audio').forEach(function (otherAudio) {
          if (otherAudio !== activated) {
            otherAudio.pause();
            //otherAudio.currentTime = 0;
          }
        });
      });
    });

    // Log session notes
    let sessionNotes = document.querySelector("textarea[name='session_notes']");

    if (sessionNotes) {
      sessionNotes.addEventListener('input', function (event) {
        fitness_meta.notes = event.target.value;
        Wized.data.v.session_notes = event.target.value;
      });
    }

    // Start audio and create session
    fitness_audio_main.play();
    Wized.data.v.session_metadata = fitness_meta;
    await Wized.requests.execute('create_session');
  });

  // listen for "completed" event
  document.addEventListener('completed', async function (event) {
    Wized.data.v.session_metadata = fitness_meta;
    await Wized.requests.execute('complete_session');
  });
});
